import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'
const api = {
  applyBasicInfo: PREFIX_SCC_API + 'fchild/appoint/addAppoint.do',
  cms4Insurance: `${utils.hostname('cms')}/publish/890/insurance.json`
}

export default {
  namespaced: true,
  state: {
    //保险信息
    insuranceInfo: {},
    //出行人组件选择的数据
    schemeTravPerson: undefined,
    //取票人组件选择的数据
    schemeTicketTaker: undefined,
    //是否支持价格日历
    supportPriceCalendar: false,
    //选择的价格日历日期
    selectPriceCalendarDate: null,
    startTime: '',
    endTime: '',
    //出行人组件
    travelPersonList: [],
    //成人可领取数量
    travelAdultPersonNum: 1,
    //儿童可领取数量
    travelChildPersonNum: 1,
    //当前选中的保险
    currentProduct: {},
    //儿童监护人
    guardianInfo: {},
    //选择的成人
    selectAdultList: [],
    //选择的儿童
    selectChildList: []
  },
  mutations: {
    setInsuranceInfo(state, info) {
      state.insuranceInfo = info
    },
    setCurrentProduct(state, product) {
      state.currentProduct = product
    },
    setSupportPriceCalendar(state, val) {
      state.supportPriceCalendar = val
    },
    setSelectPriceCalendarDate(state, val) {
      state.selectPriceCalendarDate = val
    },
    setStartTime(state, val) {
      state.startTime = val
    },
    setEndTime(state, val) {
      state.endTime = val
    },
    setTravelPersonList(state, val) {
      state.travelPersonList = val
    },
    setTravelAdultPersonNum(state, val) {
      state.travelAdultPersonNum = val
    },
    setTravelChildPersonNum(state, val) {
      state.travelChildPersonNum = val
    },
    setAdultPersonList(state, val) {
      state.selectAdultList = val
    },
    setChildPersonList(state, val) {
      state.selectChildList = val
    },
    setGuardianInfo(state, val) {
      state.guardianInfo = val
    },
    setSchemeTravPerson(state, val) {
      state.schemeTravPerson = val
    },
    setSchemeTicketTaker(state, val) {
      state.schemeTicketTaker = val
    }
  },
  actions: {
    async getCmsConfig4Insurance({ commit, state }) {
      try {
        const data_res = await fetch(`${api.cms4Insurance}`)
        const dataJson = await data_res.json()
        commit('setInsuranceInfo', dataJson.data.insuranceInfo || [])
        return dataJson
      } catch (e) {
        throw new Error(e)
      }
    },
    async getTravelPersonList({ commit, state }, { vm, isCommit }) {
      const { uid, skey } = await vm.$$ensureLogin()
      if (!uid || !skey) return
      const param = {
        uid,
        skey,
        startPage: 0,
        pageSize: 100,
        skuId: vm.$route.query.skuId || '',
        giveInsure: 1
      }
      const qs = vm.$$queryString.stringify(param)
      const url = `//soperationapi.cekid.com/soperation-api/traveling/travelingPersonList.do?${qs}`
      const result = await fetch(url)
      const dataJson = await result.json()
      if (dataJson && dataJson.data) {
        if (isCommit) {
          commit('setTravelPersonList', dataJson.data)
          return null
        } else {
          return dataJson.data
        }
      }
    }
  }
}
